import styled from 'styled-components';
import { colors } from './ColorTheme';

export const Button = styled.button`
    border-radius: none;
    text-transform: uppercase;
    cursor: pointer;
    outline: none;
    border: none;
    line-height: 1.3;
    font-size: 0.8667rem;
    font-family: GROTESK Bold;
    letter-spacing: 0.07rem;
    border: 1px solid ${colors.btnColor};
    padding: 10px 0;
`;

export const ButtonPrimary = styled(Button)`
    background-color: ${colors.projectBlue};
    color: ${colors.white};
    border: 1px solid ${colors.projectBlue};
    padding: 10px 22px;
    &:hover {
        background-color: ${colors.projectDarkBlue};
    }
`;

export const ButtonDisabled = styled(Button)`
    background-color: ${colors.btnDsiabled};
    border: 1px solid ${colors.btnDsiabled};
    color: ${colors.white};
    pointer-events: none;
`;
